import * as React from 'react';

import { dayjst } from '@/lib/dayjst';
import { orderByMultiraceType } from '@/lib/race/multirace';
import { getVelodromeByCode } from '@/lib/race/velodrome';
import { CurrentMultiraceProgramMap } from '@/modelTypes';

import ProgramBox from '../ProgramBox';
import { LinkWrapper, ListWrapper, VelodromeLink } from './style';

interface ProgramListProps {
  multiraceProgramList: CurrentMultiraceProgramMap;
}

const ProgramList: React.FC<ProgramListProps> = ({ multiraceProgramList }) => {
  return (
    <div>
      {Object.entries(multiraceProgramList).map(([code, mps], i) => (
        <React.Fragment key={`${code}-${i}`}>
          {Boolean(mps.length) && (
            <>
              <LinkWrapper>
                <VelodromeLink
                  to={`/${
                    getVelodromeByCode(Number(code)).romanName
                  }/racecard/${dayjst().format('YYYY-MM-DD')}`}
                >
                  {getVelodromeByCode(Number(code)).name}
                </VelodromeLink>
              </LinkWrapper>
              <ListWrapper>
                {orderByMultiraceType(mps).map(mp => (
                  <ProgramBox multiraceProgram={mp} key={mp.id} />
                ))}
              </ListWrapper>
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProgramList;
